import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { PlanChangePayload } from 'Interfaces/Billing';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: PlanChangePayload) =>
    $actions.billing.changePLan(dispatch, payload),
  );
};
